export default __webpack_public_path__ + "static/media/manual-snap-hover.7781e24d.png";